interface HistoricoFiltrosProps {
  search: string;
  onSearchChange: (v: string) => void;
  anoFilter: string;
  onAnoChange: (v: string) => void;
  classificacaoFilter: string;
  onClassificacaoChange: (v: string) => void;
  carreiraFilter: string;
  onCarreiraChange: (v: string) => void;
  carreiras: string[];
  anos: number[];
}

export default function HistoricoFiltros({
  search,
  onSearchChange,
  anoFilter,
  onAnoChange,
  classificacaoFilter,
  onClassificacaoChange,
  carreiraFilter,
  onCarreiraChange,
  carreiras,
  anos,
}: HistoricoFiltrosProps) {
  return (
    <div className="flex flex-col md:flex-row gap-3 mb-6 flex-wrap">
      <div className="relative flex-1 min-w-[200px]">
        <div className="w-9 h-9 flex items-center justify-center absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 pointer-events-none">
          <i className="ri-search-line text-base" />
        </div>
        <input
          type="text"
          placeholder="Pesquisar por nome ou nº..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full pl-10 pr-4 py-2.5 text-sm border border-slate-200 rounded-lg bg-white text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-slate-300"
        />
      </div>

      <select
        value={anoFilter}
        onChange={(e) => onAnoChange(e.target.value)}
        className="text-sm border border-slate-200 rounded-lg px-3 py-2.5 bg-white text-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-300 cursor-pointer"
      >
        <option value="">Todos os Anos</option>
        {anos.map((a) => (
          <option key={a} value={String(a)}>{a}</option>
        ))}
      </select>

      <select
        value={carreiraFilter}
        onChange={(e) => onCarreiraChange(e.target.value)}
        className="text-sm border border-slate-200 rounded-lg px-3 py-2.5 bg-white text-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-300 cursor-pointer"
      >
        <option value="">Todas as Carreiras</option>
        {carreiras.map((c) => (
          <option key={c} value={c}>{c}</option>
        ))}
      </select>

      <select
        value={classificacaoFilter}
        onChange={(e) => onClassificacaoChange(e.target.value)}
        className="text-sm border border-slate-200 rounded-lg px-3 py-2.5 bg-white text-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-300 cursor-pointer"
      >
        <option value="">Todas as Classificações</option>
        <option value="Excelente">Excelente</option>
        <option value="Relevante">Relevante</option>
        <option value="Adequado">Adequado</option>
        <option value="Inadequado">Inadequado</option>
        <option value="Muito Bom">Muito Bom (2023+)</option>
        <option value="Bom">Bom (2023+)</option>
        <option value="Regular">Regular (2023+)</option>
      </select>
    </div>
  );
}
